export default __webpack_public_path__ + "static/media/NewOffice.732afe9e.jpg";